// Styles for OffersBenefitCards go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { theme } from '@marriott/mi-ui-library-shop';
import { font, mediaQuery } from '../../utils/styles';

export const StyledOffersBenefitCards = styled.div`
  .benefitcard-container {
    width: 100%;
    padding-top: ${toRem(64)};
    @media ${mediaQuery.tabletMax} {
      padding-bottom: ${toRem(48)};
      padding-top: ${toRem(48)};
    }
    @media ${mediaQuery.tabletOnly} {
      padding-bottom: ${toRem(48)};
      padding-top: ${toRem(48)};
    }
    @media ${mediaQuery.mobileOnly} {
      padding-top: ${toRem(48)};
      padding-bottom: ${toRem(48)};
    }
    .benefitcard-wrapper {
      display: flex;
      flex-direction: column;
      .benefitcard-title {
        font-family: ${font.Swiss721BTRegular};
        font-style: normal;
        font-weight: 700;
        text-transform: capitalize;
        padding-bottom: ${toRem(48)};
        @media ${mediaQuery.allTablets} {
          padding-bottom: ${toRem(32)};
          font-size: ${toRem(35)};
        }
      }
      .benefitcard-outer {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 24px;
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        .card-grid {
          box-sizing: border-box;
          .description {
            color: ${theme.color['dark-gray-13']};
            font-size: 16px;
          }
        }
        @media ${mediaQuery.allTablets} {
          grid-template-columns: repeat(2, 1fr);
        }
        @media ${mediaQuery.mobile} {
          grid-template-columns: 1fr;
          padding: 0 16px;
        }
      }
    }
  }
`;
